<template>
  <v-card flat class="layout row wrap pa-3 justify-space-between shadow">
    <v-flex xs12>
      <v-data-table
        item-key="id"
        hide-actions
        :headers="headers"
        :items="summary.items"
      >
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td class="font-weight-bold">{{ item.standard }}</td>
            <td class="font-weight-bold">{{ item.no_of_standard }}</td>
            <td class="font-weight-bold">{{ item.total_score }}</td>
            <td class="font-weight-bold">{{ item.qualifying_score }}</td>
            <td class="font-weight-bold">{{ item.score_obtained }}</td>
            <td class="font-weight-bold" :class="item.status">
              {{ item.status }}
            </td>
          </tr>
        </template>
        <template slot="footer" v-if="total">
          <tr>
            <td class="font-weight-bold">Award of Best Practice</td>
            <td colspan="5">
              <strong>{{ summary.best_award_sections }}</strong>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Excellence Award</td>
            <td colspan="5">
              <strong>{{ summary.excellence_award }}</strong>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Summary</td>
            <td colspan="5">
              <strong>{{ summary.summary }}</strong>
            </td>
          </tr>

          <tr>
            <td class="font-weight-bold" :class="value.recommendation">
              Evaluation Team Recommendations
            </td>
            <td colspan="5" class="py-0 px-2">
              <v-autocomplete
                solo
                flat
                single-line
                hide-details
                v-validate="'required'"
                :items="recommendations"
                data-vv-name="recommendation"
                v-model="value.recommendation"
                :data-vv-as="$t('recommendation')"
                :placeholder="$t('recommendation')"
                :error-messages="errors.collect('recommendation')"
              />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold" :class="value.decision">
              AICS Board Decision
            </td>
            <td colspan="5" class="py-0 px-2">
              <v-autocomplete
                solo
                flat
                single-line
                hide-details
                :items="decisions"
                v-validate="'required'"
                data-vv-name="decision"
                v-model="value.decision"
                :data-vv-as="$t('decision')"
                :placeholder="$t('decision')"
                :error-messages="errors.collect('decision')"
              />
            </td>
          </tr>
          <tr v-if="value.decision == 'Certified'">
            <td class="font-weight-bold">Certificate Issue Date</td>
            <td colspan="5" class="py-0 px-2">
              <date
                solo
                flat
                single-line
                hide-details
                v-model="value.issue_date"
              />
            </td>
          </tr>
          <tr v-if="value.decision == 'Certified'">
            <td class="font-weight-bold">Certificate Expiration Date</td>
            <td colspan="5" class="py-0 px-2">
              <date
                solo
                flat
                single-line
                hide-details
                v-model="value.expire_date"
              />
            </td>
          </tr>
          <tr v-if="value.decision == 'Deferred'">
            <td class="font-weight-bold">Remminder Date</td>
            <td colspan="5" class="py-0 px-2">
              <date
                solo
                flat
                single-line
                hide-details
                v-model="value.reminder_date"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 mt-5 v-if="total" class="di-flex justify-end">
      <v-btn
        dark
        flat
        color="teal"
        :loading="loading"
        @click="downloadReport(cso, 'assessment_report')"
        v-if="
          can('view_assessments') &&
            cso.assessment_report &&
            value.type == 'Primary-Assessment'
        "
      >
        <v-icon>mdi-arrow-down-bold-box-outline</v-icon>
        <span class="ml-2 mt-1">Assessment Report</span>
      </v-btn>

      <v-btn
        dark
        flat
        color="teal"
        :loading="loading"
        @click="downloadReport(cso, 're_assessment_report')"
        v-if="
          can('view_assessments') &&
            cso.re_assessment_report &&
            value.type == 'Re-Assessment'
        "
      >
        <v-icon>mdi-arrow-down-bold-box-outline</v-icon>
        <span class="ml-2 mt-1">Re-Assessment Report</span>
      </v-btn>

      <v-spacer />
      <v-btn
        dark
        color="primary"
        class="shadow-md"
        :loading="loading"
        @click="submitAssessment"
        v-if="can('edit_assessments')"
        >Submit Assessment</v-btn
      >
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: "scoreCard",
  props: ["assessment_id", "score_cards", "total", "value", "cso"],

  data() {
    return {
      result: {},
      loading: false,
      decisions: ["Pending", "Certified", "Deferred"],
      recommendations: [
        "Recommended for certification",
        "Recommended for deferral for a period of 3 Months",
        "Recommended for deferral for a period of 6 Months",
        "Recommended for deferral for a period of 9 Months",
        "Recommended for deferral for a period of 1 year"
      ]
    };
  },

  computed: {
    headers: vm => [
      { text: vm.$t("standards"), value: "standard", sortable: false },
      {
        text: vm.$t("no_of_standard"),
        value: "no_of_standard",
        sortable: false
      },
      {
        text: vm.$t("total_score"),
        value: "total_score",
        sortable: false
      },
      {
        text: vm.$t("qualifying_score"),
        value: "qualifying_score",
        sortable: false
      },
      {
        text: vm.$t("score_obtained"),
        value: "score_obtained",
        sortable: false
      },
      {
        text: vm.$t("status"),
        sortable: false,
        value: "status"
      }
    ],
    summary() {
      let co_status = 1,
        co_standards = 0,
        co_total_score = 0,
        co_obtained_score = 0,
        failed_compulsory = 0,
        co_qualifying_score = 0,
        regular_status = 1,
        regular_standards = 0,
        regular_total_score = 0,
        regular_obtained_score = 0,
        regular_qualifying_score = 0;

      let best_award_sections = [];
      let pro_rated_regular_sections = [];
      let pro_rated_compulsory_sections = [];

      this.score_cards.forEach(result => {
        let total_regular = result.total_regular;
        let total_compulsory = result.total_compulsory;

        co_standards += total_compulsory;
        co_total_score += total_compulsory * 4;
        co_obtained_score += result.compulsory_score;
        failed_compulsory += result.failed_compulsory;

        co_qualifying_score += total_compulsory * result.qualified_compulsory;

        regular_standards += total_regular;
        regular_total_score += total_regular * 4;
        regular_obtained_score += result.regular_score;
        regular_qualifying_score +=
          (4 * total_regular * result.qualified_regular) / 100;

        if (
          total_regular + total_compulsory > 0 &&
          result.regular_score + result.compulsory_score >=
            (total_regular + total_compulsory) * 4 * 0.9
        )
          best_award_sections.push(this.prettySection(result.section));

        if (result.pro_rated_compulsory > 0)
          pro_rated_compulsory_sections.push({
            section: result.section,
            counts: result.pro_rated_compulsory
          });

        if (result.pro_rated_regular > 0)
          pro_rated_regular_sections.push({
            section: result.section,
            counts: result.pro_rated_compulsory
          });
      });

      co_status = failed_compulsory == 0;
      regular_status = regular_obtained_score >= 0.5 * regular_total_score;

      let summary = "Recommended for certification";
      if (!co_status)
        summary = `The organization is not qualifying at ${failed_compulsory} compulsory standards`;
      if (!regular_status)
        if (!co_status)
          summary += ` and did not obtain at least 50% regular standard scores.`;
        else
          summary = `The organization did not obtain at least 50% regular standard scores.`;

      let items = [
        {
          standard: this.$t("compulsory"),
          total_score: co_total_score,
          no_of_standard: co_standards,
          score_obtained: co_obtained_score,
          qualifying_score: co_qualifying_score,
          status: co_status ? "Qualified" : "Not-Qualified"
        },
        {
          standard: this.$t("regular"),
          total_score: regular_total_score,
          no_of_standard: regular_standards,
          score_obtained: regular_obtained_score,
          qualifying_score: regular_qualifying_score,
          status: regular_status ? "Qualified" : "Not-Qualified"
        },
        {
          standard: this.$t("total"),
          no_of_standard: regular_standards + co_standards,
          total_score: regular_total_score + co_total_score,
          score_obtained: regular_obtained_score + co_obtained_score,
          qualifying_score: regular_qualifying_score + co_qualifying_score,
          status: regular_status && co_status ? "Qualified" : "Not-Qualified"
        }
      ];

      return {
        items,
        summary,
        failed_compulsory,
        best_award_sections:
          best_award_sections.length > 0
            ? best_award_sections.join(", ")
            : "NO",
        pro_rated_regular_sections,
        pro_rated_compulsory_sections,
        decision: this.value && this.value.decision,
        issue_date: this.value && this.value.issue_date,
        expire_date: this.value && this.value.expire_date,
        reminder_date: this.value && this.value.reminder_date,
        recommendation: this.value && this.value.recommendation,
        excellence_award: best_award_sections.length == 5 ? "YES" : "NO"
      };
    }
  },

  methods: {
    submitAssessment() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          if (this.value.decision == "Certified")
            this.value.reminder_date = null;
          else if (this.value.decision == "Deferred") {
            this.value.expire_date = null;
            this.value.issue_date = null;
          } else {
            this.value.reminder_date = null;
            this.value.expire_date = null;
            this.value.issue_date = null;
          }

          this.axios
            .post("assessments", { ...this.value, summary: this.summary })
            .then(() => {
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true
              });
              this.loading = false;
              this.$emit("submited");
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  }
};
</script>
